import { apiGet, apiPost } from "./http";

export type EnrollmentApplicationDto =
  | { found: false }
  | {
      found: true;
      applyDate: string;
      gender: string;
      ethnicity: string;
      politicalStatus: string;
      bloodType: string;
      hometown: string;
      clothingSize: string;
      idType: string;
      idNumber: string;
      organization: string;
      emergencyContact: string;
      emergencyContactPhone: string;
      reason: string;
      hasSigned: boolean;
      /** 入会申请存档的电子签名图（OSS 可访问 URL，无则为 null） */
      agreementSignatureDataUrl?: string | null;
      /** 身份证人像面、国徽面（OSS 展示 URL） */
      idCardFrontDataUrl?: string | null;
      idCardBackDataUrl?: string | null;
      /** 申请时签署的协议正文/标题/版本快照 */
      agreementSnapshotTitle?: string | null;
      agreementSnapshotVersion?: string | null;
      agreementSnapshotContent?: string | null;
      resumes: {
        startDate: string;
        endDate: string;
        organization: string;
        position: string;
        area: string;
      }[];
    };

export function fetchEnrollmentApplication(tenantLegacyId: string, memberLegacyId: string) {
  return apiGet<EnrollmentApplicationDto>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/members/${encodeURIComponent(memberLegacyId)}/enrollment-application`
  );
}

export interface ActivityParticipationRow {
  activityId: string;
  title: string;
  activityType: string;
  eventDate: string;
  registrationStatus: string;
  applyDate: string;
  checkedIn: boolean;
  checkedAt?: string | null;
  pointsAwarded?: number;
  activityStatus: string;
}

export function fetchMemberActivityParticipation(tenantLegacyId: string, memberLegacyId: string) {
  return apiGet<ActivityParticipationRow[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/members/${encodeURIComponent(memberLegacyId)}/activity-participation`
  );
}

export interface MemberFeeRecordRow {
  id: string;
  date: string;
  type: string;
  amount: number;
  method: string;
  status: string;
  /** 入会/续费上传的缴费凭证图（OSS 展示 URL），无则 null */
  paymentProofUrl?: string | null;
}

export function fetchMemberFeeRecords(tenantLegacyId: string, memberLegacyId: string) {
  return apiGet<MemberFeeRecordRow[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/members/${encodeURIComponent(memberLegacyId)}/fee-records`
  );
}

export function postMemberManualPoints(
  tenantLegacyId: string,
  memberLegacyId: string,
  body: { delta: number; category?: string; memo: string; activityLegacyId?: string }
) {
  return apiPost<{ points: number; relatedActivityLegacyId?: string | null }>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/members/${encodeURIComponent(memberLegacyId)}/manual-points`,
    body
  );
}
